<template>
  <div class="dialog-wrap">
    <el-dialog title="用户信息"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="close()"
               @open="open()"
               width="450px">
      <div class="senioBox">
        <div class="seniorItem">
          <div class="invite">
            <span class="blue"></span>
            <p>基础信息</p>
          </div>
          <div class="edit"
               @click="handleEdit()"
               v-if="editFlag">编辑</div>
          <el-form ref="userForm"
                   label-width="63px"
                   class="userForm"
                   style="marginLeft:-30px;">
            <el-form-item label="头像">
              <!-- <el-avatar :src="senior.avatar"></el-avatar> -->
              <el-upload class="avatar-uploader"
                         :action="imgUploadUrl"
                         :headers="uploadHeaders"
                         :show-file-list="false"
                         :on-success="handleUploadSuccess"
                         :before-upload="handleBeforeUpload">
                <img v-if="senior.avatar"
                     :src="senior.avatar"
                     style="width:40px;height:40px">
                <i v-else
                   class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="姓名">
              <el-input v-model="senior.realname"
                        :disabled="disabled"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="昵称">
              <el-input v-model="senior.nickname"
                        :disabled="disabled"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="性别">
              <el-radio-group v-model="senior.gender"
                              :disabled="disabled">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="2">女</el-radio>
                <el-radio :label="0">未知</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
          <div class="invite">
            <span class="blue"></span>
            <p>报考信息</p>
          </div>
          <el-form ref="userForm"
                   label-width="103px"
                   class="userForm"
                   style="marginLeft:-50px;">
            <el-form-item label="考研年份">
              <!-- @change="collegeChange" -->
              <el-select v-model="userMess.apply_year"
                         filterable
                         collapse-tags
                         :disabled="disabled"
                         placeholder="请选择"
                         style="width: 270px">
                <el-option v-for="(item, index) in  filter.year"
                           :key="index"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="报考院校">
              <el-select v-model="userMess.apply_college_code"
                         filterable
                         collapse-tags
                         :disabled="disabled"
                         placeholder="请选择"
                         style="width: 270px"
                         @change="collegeChange">
                <el-option v-for="(item, index) in $store.state.collegeList"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="报考专业">
              <el-select v-model="userMess.apply_major_code"
                         filterable
                         collapse-tags
                         :disabled="disabled"
                         placeholder="请选择"
                         style="width: 270px"
                         @change="majorChange">
                <el-option v-for="(item, index) in majorList"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                  <span>{{ `（${item.code}）${item.name}` }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="报考学院">
              <el-select v-model="userMess.apply_academy_code"
                         filterable
                         collapse-tags
                         :disabled="disabled"
                         placeholder="请选择"
                         style="width: 270px"
                         @change="academyChange">
                <el-option v-for="(item, index) in academyList"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                  <span>{{ `${item.name}` }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <!-- {{userMess.test_subject_codes}} -->
            <el-form-item label="考试科目">
              <el-select v-model="userMess.test_subject_codes"
                         multiple
                         clearable
                         placeholder="请选择"
                         :disabled="disabled"
                         style="width: 270px"
                         @change="handleSubject">
                <el-option v-for="item in subjectsList"
                           :key="item.subject_code"
                           :label="item.subject_name"
                           :value="item.subject_code">
                  <span>{{
                    `（${item.subject_code}）${item.subject_name}`
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>

          </el-form>
          <el-form ref="userForm"
                   label-width="63px"
                   class="userForm"
                   style="marginLeft:-30px;"
                   v-if="!isType">
            <div class="invite"
                 style="marginLeft:10px;marginBottom:20px">
              <span class="blue"></span>
              <p>联系方式</p>
            </div>

            <el-form-item label="手机号">
              <el-input v-model="senior.mobile"
                        disabled
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="微信号">
              <el-input v-model="senior.wechat"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="QQ号">
              <el-input v-model="senior.qq"
                        clearable></el-input>
            </el-form-item>
          </el-form>

          <el-form ref="userForm"
                   label-width="63px"
                   class="userForm"
                   style="marginLeft:-10px;"
                   v-else>
            <div class="invite"
                 style="marginLeft:0px;marginBottom:20px">
              <span class="blue"></span>
              <p>其他</p>
            </div>

            <el-form-item label="用户分组"
                          prop="category_id">
              <el-select v-model="senior.category_ids"
                         multiple
                         :disabled="disabled"
                         placeholder="请选择用户分组"
                         style="width: 270px;">
                <el-option v-for="item in categorys"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="帐号状态"
                          prop="status">
              <el-switch v-model="senior.status"
                         :disabled="disabled"></el-switch>
            </el-form-item>
          </el-form>
          <div class="footer"
               v-if="!disabled">
            <div class="cancle"
                 @click="close()">取消</div>
            <div class="confirm"
                 @click="handleSubmit()">确认</div>
          </div>

        </div>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  memberOne,
  memberApplicant,
  subjectlicant,
  memberUpdate,
  memberApplicantPut,
  memberCategoryList,
} from '@/api/member'
import {
  collegeMajorList,
  majorSubjectList,
  academyList,
  majorinfo,
} from '@/api/common'
import { imgUploadUrl, uploadHeaders } from '@/config/index'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rowDetail: {
      type: Object,
      default: () => {
        return {}
      },
    },
    editFlag: {
      type: Boolean,
      default: () => {
        return true
      },
    },
    isType: {
      type: Boolean,
      default: () => {
        return false
      },
    },
  },
  data() {
    return {
      categorys: [],
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      dialogVisible: this.visible,
      senior: {},
      filter: {
        year: [
          {
            label: '2024年',
            value: '2024',
          },
          {
            label: '2023年',
            value: '2023',
          },
          {
            label: '2022年',
            value: '2022',
          },
          {
            label: '2021年',
            value: '2021',
          },
          {
            label: '2020年',
            value: '2020',
          },
        ],
      },
      majorList: [],
      academyList: [],
      directionList: [],
      subjectsList: [],
      scoreList: [],
      honor: ['初试第一', '专业课第一', '总分第一'],
      otherHonor: [],
      disabled: true,
      userMess: {},
      subjectName: [],

      subjectCode: [],
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
  },
  methods: {
    fetchCategoryList() {
      memberCategoryList({ isPaging: 0 }).then((res) => {
        this.categorys = res.list
      })
    },
    handleUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.senior.avatar = res.data.url
      } else {
        this.$message.error(res.error)
      }
    },
    handleBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    handleEdit() {
      this.disabled = false
    },
    close() {
      this.disabled = true
      this.$emit('close')
    },
    open() {
      this.fetchCategoryList()
      this.getDetail()
      this.getSubjectAplicat()
      this.$nextTick(() => {
        this.getApplicate()
      })

      this.$store.dispatch('getAllColleges')
    },

    getDetail() {
      memberOne({
        id: this.rowDetail.uid ? this.rowDetail.uid : this.rowDetail.id,
      }).then((res) => {
        this.senior = res
        if (this.senior.status == 1) {
          this.senior.status = true
        } else {
          this.senior.status = false
        }
        if (this.senior.category_ids != '') {
          this.senior.category_ids = this.senior.category_ids.split(',')
          this.senior.category_ids = this.senior.category_ids.map((item) =>
            Number(item)
          )
        }

        // this.senior.test_subject_codes =
        //   this.senior.test_subject_codes.split(',')
        // this.scoreList = []
        // this.senior.test_subject_names.split(',').map((item, index) => {
        //   this.senior.test_subject_scores.split(',').map((v, id) => {
        //     if (index == id) {
        //       this.scoreList.push({
        //         subjectName: item,
        //         score: v,
        //       })
        //     }
        //   })
        // })
        // this.scoreList.map((items, k) => {
        //   this.senior.test_subject_codes.map((p, i) => {
        //     if (k == i) {
        //       items.code = ''
        //       items.code = p
        //     }
        //   })
        // })
        // this.honor = []
        // let otherHonor = []
        // if (this.senior.honor_tags != '') {
        // this.honor = this.senior.honor_tags.split(',')
        // otherHonor = this.senior.honor_tags.split(',').filter((v) => {
        //   return v.includes('#')
        // })
        // this.otherHonor = otherHonor.toString()
        // }
      })
    },
    // 查询报考信息
    getApplicate() {
      memberApplicant({
        uid: this.rowDetail.uid ? this.rowDetail.uid : this.rowDetail.id,
      }).then((res) => {
        if (res) {
          this.userMess = res
          this.getMajor(res.apply_college_code)
          this.getAcademy(res.apply_college_code, res.apply_major_code)
          this.majorDirect(res.apply_college_code, res.apply_major_code)
          this.getSubjectsByMajorCode(
            res.apply_college_code,
            res.apply_major_code
          )
        } else {
          this.userMess.apply_year = ''
          this.userMess.apply_college_code = ''
          this.userMess.apply_major_code = ''
          this.userMess.apply_academy_code = ''
          this.$set(this.userMess, 'test_subject_codes', [])
        }
      })
    },
    //查询科目信息
    getSubjectAplicat() {
      subjectlicant({
        uid: this.rowDetail.uid ? this.rowDetail.uid : this.rowDetail.id,
      }).then((res) => {
        let code = []
        let name = []
        res.list.map((item) => {
          code.push(item.code)
          name.push(item.name)
        })
        this.userMess.test_subject_names = name.join(',')
        if (code) {
          this.$set(this.userMess, 'test_subject_codes', code)
        } else {
          this.$set(this.userMess, 'test_subject_codes', [])
        }
      })
    },
    // 报考信息修改
    messPut() {
      this.formateSenior()

      let data = {
        uid: this.rowDetail.uid ? this.rowDetail.uid : this.rowDetail.id,
        college_code: this.userMess.apply_college_code,
        college_name: this.userMess.apply_college_name,
        major_code: this.userMess.apply_major_code,
        major_name: this.userMess.apply_major_name,
        apply_year: this.userMess.apply_year,
        apply_academy_code: this.userMess.apply_academy_code,
        apply_academy_name: this.userMess.apply_academy_name,
        subject_names: this.subjectName.join(','),
        subjects: this.subjectCode,
        // apply_academy_code: this.userMess.apply_academy_code,
        // apply_academy_name: this.userMess.apply_academy_name,
      }

      memberApplicantPut(data).then((res) => {
        // if (!res) {
        this.close()
        this.$message.success(`修改成功`)
        // }
      })
    },
    handleSubmit() {
      let data = {
        id: this.senior.id,
        avatar: this.senior.avatar,
        realname: this.senior.realname,
        // nickname: this.senior.nickname,
        gender: this.senior.gender,
        wechat: this.senior.wechat,
        qq: this.senior.qq,
        category_ids: this.senior.category_ids
          ? this.senior.category_ids.join(',')
          : '',
        status: this.senior.status ? 1 : 0,
      }
      memberUpdate(data).then((res) => {
        if (res.id) {
          this.messPut()
        }
      })
    },
    collegeChange(e) {
      this.userMess.apply_major_code = ''
      this.userMess.apply_major_name = ''
      this.userMess.apply_academy_code = ''
      this.userMess.apply_academy_name = ''
      this.$set(this.userMess, 'test_subject_codes', [])
      this.userMess.test_subject_names = ''
      this.userMess.apply_direction_code = ''
      this.userMess.apply_direction_name = ''
      this.userMess.apply_college_name = this.$store.state.collegeList.find(
        (item) => {
          return item.code === e //筛选出匹配数据
        }
      ).name
      this.getMajor(this.userMess.apply_college_code)
    },
    majorChange(e) {
      this.$set(this.userMess, 'test_subject_codes', [])
      this.userMess.test_subject_names = ''
      this.userMess.apply_academy_code = ''
      this.userMess.apply_academy_name = ''
      this.userMess.apply_major_name = this.majorList.find((item) => {
        return item.code === e //筛选出匹配数据
      }).name
      this.getAcademy(
        this.userMess.apply_college_code,
        this.userMess.apply_major_code
      )
      // this.majorDirect(
      //   this.userMess.apply_college_code,
      //   this.userMess.apply_major_code
      // )
      this.getSubjectsByMajorCode(
        this.userMess.apply_college_code,
        this.userMess.apply_major_code
      )
    },
    academyChange(e) {
      this.$set(this.userMess, 'test_subject_codes', [])
      this.userMess.test_subject_names = ''
      this.userMess.apply_academy_name = this.academyList.find((item) => {
        return item.code === e //筛选出匹配数据
      }).name
    },
    directionChange(e) {
      this.userMess.apply_direction_name = this.directionList.find((item) => {
        return item.direction_code === e //筛选出匹配数据
      }).direction
    },
    handleSubject(e) {
      // this.subjectsList.map((item) => {
      //   if (item.subject_code == e) {
      //     this.subjectName.push(item.subject_name)
      //   }
      // })
      // let scorep = []
      // this.scoreList.map((item) => {
      //   e.map((v) => {
      //     if (item.code == v) {
      //       scorep.push({
      //         subjectName: item.subjectName,
      //         score: item.score,
      //         code: v,
      //       })
      //     }
      //   })
      // })
      // this.scoreList = scorep
    },
    //录取专业
    getMajor(college_code) {
      collegeMajorList({
        college_code: college_code,
        isPaging: 0,
      }).then((res) => {
        this.majorList = res.list || []
      })
    },
    //录取学院
    getAcademy(college_code, major_code) {
      academyList({
        college_code: college_code,
        isPaging: 0,
        major_code: major_code,
      }).then((res) => {
        this.academyList = res.list || []
      })
    },
    // 录取方向
    majorDirect(college_code, major_code) {
      majorinfo({
        isPaging: 0,
        college_code: college_code,
        major_code: major_code,
      }).then((res) => {
        if (res.academys && res.academys.length) {
          let list = res.academys.map((item) => item.directions).flat()
          let obj = {}
          for (let item of list) {
            if (!obj[item.direction_code]) {
              obj[item.direction_code] = item
            }
          }
          this.directionList = Object.values(obj)
        }
      })
    },
    // 考试科目
    getSubjectsByMajorCode(college_code, major_code) {
      let query = {
        isPaging: 0,
        college_code: college_code,
        major_code: major_code,
      }
      majorSubjectList(query).then((res) => {
        this.subjectsList = res.list || []
      })
    },
    formateSenior() {
      let arr = []
      this.subjectCode = []
      this.subjectName = []
      this.userMess.test_subject_codes.forEach((item) => {
        arr.push(
          this.subjectsList.find((v) => {
            return v.subject_code === item //筛选出匹配数据
          }).subject_name
        )
      })

      this.userMess.test_subject_codes.map((item, index) => {
        this.subjectCode.push({
          code: item,
          college_code: this.userMess.apply_college_code,
        })
      })

      arr.map((item, index) => {
        this.userMess.test_subject_codes.map((items, p) => {
          if (index == p) {
            this.subjectName.push(`(${items})${item}`)
          }
        })
      })
    },
  },
}
</script>

<style lang="less" scoped>
/* 穿透 scoped 样式，修改输入框边框 */
::v-deep .inptScore .el-input__inner {
  border: none; /* 去掉默认边框 */
  box-shadow: none; /* 去掉聚焦时的阴影（可选，根据需求） */
}
::v-deep .el-form-item--small .el-form-item__label {
  font-size: 12px;
}

/* 去掉聚焦状态的边框（避免点击后出现边框） */
::v-deep .inptScore .el-input__inner:focus {
  border: none;
  box-shadow: none;
}
.dialog-wrap {
  ::v-deep .el-dialog__header {
    background: #ecf2fe;
  }
  .senioBox {
    display: flex;
    .footer {
      display: flex;
      justify-content: flex-end;
      .cancle {
        text-align: center;
        font-size: 14px;
        width: 56px;
        height: 36px;
        line-height: 36px;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #dcdfe6;
        margin-right: 10px;
      }
      .confirm {
        text-align: center;
        width: 56px;
        height: 36px;
        font-size: 14px;
        line-height: 36px;
        color: #fff;
        background: #1f86fe;
        border-radius: 4px 4px 4px 4px;
      }
    }
    .seniorItem {
      margin-left: 10px;
      position: relative;
      width: 400px;

      .invite {
        margin-left: -10px;
        margin-top: 12px;
        display: flex;
        align-items: center;
        font-weight: 700;
        font-size: 14px;
        color: #303133;

        .blue {
          margin-right: 6px;
          display: inline-block;
          width: 4px;
          height: 16px;
          background: #409eff;
          border-radius: 4px 4px 4px 4px;
        }
      }
      .edit {
        cursor: pointer;
        position: absolute;
        right: 30px;
        top: -10px;
        text-align: center;
        font-weight: 400;
        font-size: 14px;
        color: #409eff;
        width: 56px;
        height: 32px;
        line-height: 32px;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #409eff;
      }
      .userForm {
        width: 350px;
        margin-top: 14px;
      }
      .score {
        width: 180px;
        border-radius: 3px 3px 3px 3px;
        border: 1px solid #dddddd;
        margin-top: 10px;
        display: flex;
        height: 35px;
        position: relative;
        .preScore {
          font-size: 12px;
          position: absolute;
          right: 5px;
        }

        .subjectName {
          min-width: 100px;
          height: 35px;
          padding-left: 6px;
          padding-right: 6px;
          line-height: 35px;
          font-size: 10px;
          display: inline-block;
          background: #eeeeee;
          border-radius: 1px 0px 0px 1px;
        }
      }
    }
  }
  .submit {
    cursor: pointer;
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
    font-size: 14px;
    .cancle {
      text-align: center;
      width: 56px;
      height: 36px;
      line-height: 36px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #dcdfe6;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      margin-right: 18px;
    }
    .confirm {
      width: 56px;
      height: 36px;
      color: #fff;
      text-align: center;
      line-height: 36px;
      background: #1f86fe;
      border-radius: 4px 4px 4px 4px;
    }
  }
}
</style>
